<mat-icon class="mep-dialog-header-icon" svgIcon="mep_favorite"></mat-icon>
<div class="mep-dialog-title">
	{{ "mep.components.homescreen.edit-favorites" | translate }}
</div>
<mat-dialog-content>
	@for (item of favorites; track item; let i = $index) {
		<div class="scrollbox">
			@if ((item.card < 15 && item.card !== 11 && item.card !== 12) || item.card >= 20) {
				<div>
					<div *appRequiresPermission="item.reqPermission; entity: item.linkEntity">
						@if (item.function !== "openEdit") {
							<mat-card
								tabindex="0"
								class="mep-fav-btn"
								(click)="onSelectCard(item.id)"
								(keydown.enter)="onSelectCard(item.id)"
								[ngClass]="{'card-selected mat-elevation-z4': getSelected(item.id)}"
							>
								@if (!item.enabled) {
									<mat-icon class="mep-icon" svgIcon="{{ item.icon }}"></mat-icon>
								}
								@if (item.enabled) {
									<mat-icon class="mep-icon-active" svgIcon="{{ item.icon }}"></mat-icon>
								}
								@if (!item.enabled) {
									<mat-card-title>{{ item.label | translate }}</mat-card-title>
								}
								@if (item.enabled) {
									<mat-card-title class="mep-card-title-active">{{ item.label | translate }} </mat-card-title>
								}
							</mat-card>
						}
					</div>
				</div>
			}
			@if (item.card === 11 || item.card === 12) {
				<div>
					<div *appRequiresPermission="item.reqPermission; entity: item.linkEntity">
						@if (item.function !== "openEdit") {
							<mat-card
								tabindex="0"
								class="mep-fav-btn"
								(click)="onSelectCard(item.id)"
								(keydown.enter)="onSelectCard(item.id)"
								[ngClass]="{'card-selected mat-elevation-z4': getSelected(item.id)}"
							>
								@if (!item.enabled) {
									<mat-icon class="mep-icon" svgIcon="{{ item.icon }}"></mat-icon>
								}
								@if (item.enabled) {
									<mat-icon class="mep-icon-active" svgIcon="{{ item.icon }}"></mat-icon>
								}
								@if (!item.enabled) {
									<mat-card-title>{{ item.label | translate }}</mat-card-title>
								}
								@if (item.enabled) {
									<mat-card-title class="mep-card-title-active">{{ item.label | translate }} </mat-card-title>
								}
							</mat-card>
						}
					</div>
				</div>
			}
			<!-- for all roles: display my profile -->
			@if (item.card === 15 && !isCustomerManager && !isExternal) {
				<div>
					<div *appRequiresPermission="item.reqPermission; entity: item.linkEntity; idNotRelevant: true">
						@if (item.function !== "openEdit") {
							<mat-card
								tabindex="0"
								class="mep-fav-btn"
								(click)="onSelectCard(item.id)"
								(keydown.enter)="onSelectCard(item.id)"
								[ngClass]="{'card-selected mat-elevation-z4': getSelected(item.id)}"
							>
								@if (!item.enabled) {
									<mat-icon class="mep-icon" svgIcon="{{ item.icon }}"></mat-icon>
								}
								@if (item.enabled) {
									<mat-icon class="mep-icon-active" svgIcon="{{ item.icon }}"></mat-icon>
								}
								@if (!item.enabled) {
									<mat-card-title>{{ item.label | translate }}</mat-card-title>
								}
								@if (item.enabled) {
									<mat-card-title class="mep-card-title-active">{{ item.label | translate }} </mat-card-title>
								}
							</mat-card>
						}
					</div>
				</div>
			}
			<!-- for all roles: skill edit -->
			@if (item.card === 16 && !deactivateSkillEdit && !isCustomerManager && !isExternal) {
				<div>
					<div *appRequiresPermission="item.reqPermission; entity: item.linkEntity; idNotRelevant: true">
						@if (item.function !== "openEdit") {
							<mat-card
								tabindex="0"
								class="mep-fav-btn"
								(click)="onSelectCard(item.id)"
								(keydown.enter)="onSelectCard(item.id)"
								[ngClass]="{'card-selected mat-elevation-z4': getSelected(item.id)}"
							>
								@if (!item.enabled) {
									<mat-icon class="mep-icon" svgIcon="{{ item.icon }}"></mat-icon>
								}
								@if (item.enabled) {
									<mat-icon class="mep-icon-active" svgIcon="{{ item.icon }}"></mat-icon>
								}
								@if (!item.enabled) {
									<mat-card-title>{{ item.label | translate }}</mat-card-title>
								}
								@if (item.enabled) {
									<mat-card-title class="mep-card-title-active">{{ item.label | translate }} </mat-card-title>
								}
							</mat-card>
						}
					</div>
				</div>
			}
			<!-- for view my absence list -->
			@if (item.card >= 17 && item.card < 20) {
				<div>
					<div
						*appRequiresPermission="item.reqPermission; entity: item.linkEntity; exactMatch: true; idNotRelevant: true"
					>
						@if (item.function !== "openEdit") {
							<mat-card
								tabindex="0"
								class="mep-fav-btn"
								(click)="onSelectCard(item.id)"
								(keydown.enter)="onSelectCard(item.id)"
								[ngClass]="{'card-selected mat-elevation-z4': getSelected(item.id)}"
							>
								@if (!item.enabled) {
									<mat-icon class="mep-icon" svgIcon="{{ item.icon }}"></mat-icon>
								}
								@if (item.enabled) {
									<mat-icon class="mep-icon-active" svgIcon="{{ item.icon }}"></mat-icon>
								}
								@if (!item.enabled) {
									<mat-card-title>{{ item.label | translate }}</mat-card-title>
								}
								@if (item.enabled) {
									<mat-card-title class="mep-card-title-active">{{ item.label | translate }} </mat-card-title>
								}
							</mat-card>
						}
					</div>
				</div>
			}
		</div>
	}
</mat-dialog-content>
<div class="mep-move-actions">
	<button class="mep-btn-dialog-secondary" (click)="dialogRef.close()" appEscapeHotkey>
		{{ "mep.components.skillgroup.close" | translate }}
	</button>
	<button class="mep-btn-dialog-primary" (click)="saveFavorites()" appSaveHotkey>
		{{ "mep.components.skillgroup.save" | translate }}
	</button>
</div>
